import React, { useCallback } from 'lib/react';
import {
  EVButton, EVGrid, EVWbSunnyOutlinedIcon, makeStyles, EVRoof3DIcon,
} from 'lib/components';
import PropTypes from 'prop-types';
import { NEW_UNIFIED_SKUS } from 'constants/AppConstants';

export const useStyles = makeStyles((theme) => ({
  trueDesign: {
    backgroundColor: theme.evPalette.salt[100],
    borderColor: theme.evPalette.ocean[600],
    padding: '10px 12px',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
    textTransform: 'none',
  },
  trueDesignLabel: {
    gap: '8px',
    whiteSpace: 'nowrap',

  },
}));

function TrueDesignLink({
  reportId, productName, primaryProductID, showTrueDesignButton,
}) {
  const classes = useStyles();

  const IconComponent = useCallback((props) => (
    NEW_UNIFIED_SKUS.includes(primaryProductID)
      ? <EVRoof3DIcon {...props} />
      : <EVWbSunnyOutlinedIcon htmlColor="#007CAD" {...props} />
  ), [primaryProductID]);

  const redirectURL = NEW_UNIFIED_SKUS.includes(primaryProductID)
    ? `/property/${reportId}`
    : `/truedesign/${reportId}`;

  if (showTrueDesignButton) {
    return (
      <EVGrid container wrap="nowrap" className={classes.trueDesignLabel}>
        <IconComponent htmlColor="#007CAD" />
        {productName}
      </EVGrid>
    );
  }
  return (
    <EVButton
      id={`truedesign-${reportId}`}
      variant="outlined"
      color="primary"
      className={classes.trueDesign}
      classes={{ label: classes.trueDesignLabel }}
      href={redirectURL}
      onClick={(e) => e.stopPropagation()}
    >
      <IconComponent />
      {productName}
    </EVButton>
  );
}
TrueDesignLink.defaultProps = {
  showTrueDesignButton: false,
};

TrueDesignLink.propTypes = {
  reportId: PropTypes.number.isRequired,
  productName: PropTypes.string.isRequired,
  primaryProductID: PropTypes.number.isRequired,
  showTrueDesignButton: PropTypes.bool,
};

export default TrueDesignLink;
